import { extractProductGroups } from "../StringUtils.js";
const extractProductSkus = (content) => {
  const regex = /<product stacklineSku="([^"]+)">/g;
  const productSkus = [];
  let match;
  while ((match = regex.exec(content)) !== null) {
    productSkus.push(match[1]);
  }
  return productSkus;
};
const processProductGroupTags = (text) => {
  let result = "";
  let currentPos = 0;
  let groupIndex = 0;
  while (currentPos < text.length) {
    const groupStart = text.indexOf("<product_group>", currentPos);
    if (groupStart === -1) {
      result += text.substring(currentPos);
      break;
    }
    result += text.substring(currentPos, groupStart);
    const groupEnd = text.indexOf("</product_group>", groupStart);
    if (groupEnd === -1) {
      break;
    }
    result += `|||PRODUCT_GROUP_${groupIndex}|||`;
    groupIndex++;
    currentPos = groupEnd + 16;
  }
  return result;
};
const extractStreamingProductGroups = (text) => {
  const groups = extractProductGroups(text);
  const streamingGroups = /* @__PURE__ */ new Map();
  groups.forEach((group, index) => {
    const skus = group.products.map((p) => p.stacklineSku);
    streamingGroups.set(index, skus);
  });
  return streamingGroups;
};
export {
  extractProductSkus,
  extractStreamingProductGroups,
  processProductGroupTags
};
//# sourceMappingURL=productGroupParser.js.map
